import { FlaskConical, Cloud, Building2, Scale, Landmark, Coins, Users, Rocket } from "lucide-react"

const FACILITIES = [
  { label: "State-of-the-art lab facilities", icon: FlaskConical },
  { label: "Computing and cloud infrastructure", icon: Cloud },
  { label: "Co-working and office spaces at IIT Ropar and PAN IIT Alumni Centre, Bangalore", icon: Building2 },
  { label: "Support in legal and financial compliances", icon: Scale },
  { label: "Access to government and PSU funding schemes", icon: Landmark },
  { label: "Access to Angel and VC funding", icon: Coins },
  { label: "Mentorship from 180+ faculty mentors, industry stalwarts and armed forces", icon: Users },
  { label: "Cohorts, incubation and acceleration programs for startups", icon: Rocket },
]

export function FacilitiesList({ className, title }) {
  return (
    <section
      className={`w-full border-b border-border py-10 px-6 md:px-20 ${className ?? ""}`}
      aria-labelledby="facilities-heading"
    >
      <header className="mb-8">
        <h2 id="facilities-heading" className="text-balance text-center text-3xl font-bold md:text-4xl">
          {title ?? (
            <>
              <span className="text-primary text-blue-600">Other</span>{" "}
              <span className="text-foreground">Facilities</span>
            </>
          )}
        </h2>
      </header>

      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3" role="list">
        {FACILITIES.map(({ label, icon: Icon }, i) => (
          <li key={i}>
            <div
              className="group cursor-pointer border-gray-400 flex items-start gap-4 rounded-xl border border-border bg-card p-4 md:p-5 text-card-foreground transition-transform duration-200 hover:-translate-y-0.5 hover:shadow-md focus-within:ring-2 focus-within:ring-ring"
              tabIndex={0}
              aria-label={label}
            >
              <div
                className="flex h-10 border border-gray-300 w-10 shrink-0 items-center justify-center rounded-lg  text-secondary-foreground "
                aria-hidden="true"
              >
                <Icon className="size-5" />
              </div>
              <p className="text-pretty leading-6">{label}</p>
            </div>
          </li>
        ))}
      </ul>
    </section>
  )
}
